<template>
	<!-- The (Left) Sidebar component -->
	<div
		v-click-outside="clickOutSideConfig"
		class="left-side-menu"
		:class="classes"
	>
		<simplebar :settings="settings" class="h-100">
			<div v-if="includeUser" class="leftbar-user">
				<a href="javascript: void(0);">
					<img
						:src="user.photo || defaultAvatar"
						alt="user-image"
						height="42"
						class="rounded-circle shadow-sm"
					/>
					<span class="leftbar-user-name">{{ user.name }}</span>
				</a>
			</div>
			<a v-else href="/" class="logo text-center">
				<span
					:class="appEnv === 'prod' ? 'logo-lg' : 'logo-lg grey-menu'"
				>
					<img
						id="side-main-logo"
						:class="appEnv === 'prod' ? '' : 'white-filter'"
						src="@/assets/images/logo.svg"
						alt="Lalamove logo"
						height="32"
					/>
				</span>
				<span
					:class="appEnv === 'prod' ? 'logo-sm' : 'logo-sm grey-menu'"
				>
					<img
						id="side-sm-main-logo"
						:class="appEnv === 'prod' ? '' : 'white-filter'"
						src="@/assets/images/icon.png"
						alt="logo"
						height="32"
					/>
				</span>
			</a>
			<AppMenu mode="vertical" />
			<button
				class="fixed-bottom py-3 px-3 btn text-light layout-button"
				@click="
					changeLeftSidebarType({
						leftSidebarType:
							type === 'fixed' ? 'condensed' : 'fixed'
					})
				"
			>
				<i
					:class="`mdi mdi-chevron-${
						type === 'fixed' ? 'left' : 'right'
					}`"
				/>
			</button>
		</simplebar>
	</div>
</template>

<script>
import simplebar from 'simplebar-vue'
import { layoutMethods } from '@/store/helpers'
import AppMenu from '@/components/AppMenu'
import usersAvatar from '@/assets/images/users-avatar.svg'

const { VUE_APP_ENV } = process.env

export default {
	components: { AppMenu, simplebar },
	props: {
		// TODO: Can be removed once we've decided on a final layout.
		theme: {
			type: String,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		user: {
			type: Object,
			required: false,
			default: () => ({})
		},
		includeUser: {
			type: Boolean,
			default: false
		},
		classes: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			settings: {
				minScrollbarLength: 60
			},
			clickOutSideConfig: {
				handler: this.handleMenuClick,
				middleware: this.middleware,
				events: ['click']
			},
			defaultAvatar: usersAvatar,
			appEnv: VUE_APP_ENV
		}
	},
	watch: {
		theme: function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.activateTheme(newVal)
			}
		},
		type: function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.activateType(newVal)
			}
		}
	},
	created: function () {
		this.activateTheme(this.theme)
		this.activateType(this.type)
	},
	methods: {
		...layoutMethods,
		handleMenuClick(e, el) {
			this.$parent.hideMenu()
		},
		middleware(event, el) {
			return !event.target.classList.contains('toggle-menu')
		},
		// TODO: Can be removed once we've decided on a final layout.
		activateTheme(theme) {
			switch (theme) {
				case 'default':
					document.body.removeAttribute('data-leftbar-theme')
					break
				case 'light':
					document.body.setAttribute('data-leftbar-theme', 'light')
					break
				case 'dark':
					document.body.setAttribute('data-leftbar-theme', 'dark')
					break
				default:
					document.body.removeAttribute('data-leftbar-theme')
					break
			}
		},
		activateType(type) {
			switch (type) {
				case 'fixed':
					document.body.removeAttribute('data-leftbar-compact-mode')
					break
				case 'condensed':
					document.body.setAttribute(
						'data-leftbar-compact-mode',
						'condensed'
					)
					document.body.classList.remove('left-side-menu-dark')
					document.body.classList.remove('boxed-layout')
					break
				case 'scrollable':
					document.body.setAttribute(
						'data-leftbar-compact-mode',
						'scrollable'
					)
					break
				default:
					document.body.removeAttribute('data-leftbar-compact-mode')
					break
			}
		}
	}
}
</script>

<style lang="scss">
.grey-menu {
	background-color: #8391a2;
}
</style>
